import { Input, DatePicker, message, Form, Spin, Row, Col, Select, Button, Space } from "antd";
import dayjs from "dayjs";
import React, { useContext, useEffect, useState } from "react";
import { useLazyQuery, useQuery } from "@apollo/client";
import { closeDialog } from "../../../library/helpers";
import DialogFooter from "../../commonComponents/dialogFooter";
import { GET_DEPARTMENTS, GET_LOCATIONS } from "../../../graphql/query";
import { UserContext } from "../../../amplify/authenticator-provider";

const HolidayForm = props => {
  const [form] = Form.useForm();
  const { RangePicker } = DatePicker;
  const {
    setLeaves,
    leave,
    index,
    edit,
    modifyCompanySchedule,
    isSubmit,
    setIsSubmit,
    createLocationHoliday,
    updateLocationHoliday,
    setHolidayList,
    setVisible,
    refetchHolidays,
    record,
    setSelectedRecord,
    selectedRowData,
    refetchLocationHolidays,
    setholidays,
  } = props;
  const { user } = useContext(UserContext);
  const [formData, setformData] = useState({
    fromDate: dayjs().toISOString(),
    toDate: dayjs().toISOString(),
    reason: "",
    leaveDescription: "",
    leaveType: "fullDay",
  });
  const [location, setLocation] = useState();
  const [department, setDepartment] = useState();
  const [loading, setloading] = useState(true);

  const initialValues = {
    rangeDate: [dayjs(formData.fromDate), dayjs(formData.toDate)],
    reason: formData?.reason,
    leaveDescription: formData?.leaveDescription,
    leaveType: formData.leaveType,
    rangeTime: [dayjs(formData.fromDate), dayjs(formData.toDate)],
    holidays: [{ holidayName: record?.name || "", date: record?.holidayDate || "" }],
  };

  useEffect(() => {
    form.setFieldValue(initialValues);
    setLocation(selectedRowData?.locationId?.toString());
    setDepartment(selectedRowData?.deparmentId?.toString());
  }, []);
  const { data: resp } = useQuery(GET_LOCATIONS, {
    variables: { companyId: user?.company?.id },
  });
  const [getDepartments, { data: departmentres }] = useLazyQuery(GET_DEPARTMENTS, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (edit && record) {
      setloading(true);

      form.setFieldsValue({
        holidays: [
          { holidayName: record?.name || record?.details, date: dayjs(record?.holidayDate) },
        ],
      });
      setloading(false);
    } else {
      setformData({ ...formData, ...leave });
      setloading(false);
    }
  }, [leave]);
  useEffect(() => {
    if (location) {
      getDepartments({
        variables: {
          locationId: location,
        },
      });
    }
  }, [location]);

  useEffect(() => {
    if (isSubmit) {
      if (edit) {
        if (!selectedRowData?.locationId) {
          modifyCompanySchedule({
            variables: {
              companyId: selectedRowData?.company,
              schedule: {
                id: record?.id,
                name: form?.getFieldValue("holidays")[0]?.holidayName,
                holidayDate: form?.getFieldValue("holidays")[0]?.date,
              },
            },
          });
        } else {
          updateLocationHoliday({
            variables: {
              holidayId: record?.id,
              holiday: {
                name: form?.getFieldValue("holidays")[0]?.holidayName,
                holidayDate: form?.getFieldValue("holidays")[0]?.date,
              },
            },
            onCompleted: resp => {
              refetchHolidays().then(res => {
                const tempLeaves = res?.data?.getHolidays?.map(item => ({
                  id: Math.random(),
                  ...item,
                }));
                if (selectedRowData) {
                  refetchLocationHolidays().then(res => {
                    setholidays(res?.data?.getLocationHolidays);
                  });
                }
                setLeaves(tempLeaves);
                setVisible(false);
              });
            },
          });
        }
      } else if (!selectedRowData?.locationId) {
        modifyCompanySchedule({
          variables: {
            companyId: selectedRowData?.company,
            schedule: {
              name: form?.getFieldValue("holidays")[0]?.holidayName,
              holidayDate: form?.getFieldValue("holidays")[0]?.date,
            },
          },
        });
      } else {
        createLocationHoliday({
          variables: {
            departmentId: department,
            holidays: form?.getFieldValue("holidays")?.map(item => ({
              name: item?.holidayName,
              holidayDate: item?.date,
            })),
            isAllDepartments: !department,
            locationId: location,
          },
          onCompleted: resp => {
            refetchHolidays().then(res => {
              const tempLeaves = res?.data?.getHolidays?.map(item => ({
                id: Math.random(),
                ...item,
              }));
              setLeaves(tempLeaves);
              setVisible(false);
            });
            refetchLocationHolidays().then(res => {
              setholidays(res?.data?.getLocationHolidays);
            });
          },
        });
      }

      setIsSubmit(false);
      setSelectedRecord(null);
    }
  }, [isSubmit]);

  return loading ? (
    <Spin tip="Loading..." />
  ) : (
    <div>
      <Form form={form} initialValues={initialValues} layout="vertical">
        {selectedRowData?.locationId && (
          <Row gutter={16} style={{ marginBottom: "20px" }}>
            <Col span={12}>
              <Form.Item label="Select Location" name="location">
                {/* <Select  /> */}
                <Select
                  getPopupContainer={() => document.getElementById("antdLocationDropdown")}
                  onChange={setLocation}
                  defaultValue={selectedRowData?.locationId?.toString()}
                  disabled={edit}
                  value={location?.toString()}
                  className="w-full"
                  placeholder="Select Location"
                  showArrow
                >
                  {(resp?.getLocations || []).map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.title}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Select Department" name="department">
                <Select
                  // getPopupContainer={() => document.getElementById("antdLocationDropdown")}
                  onChange={setDepartment}
                  value={department?.toString()}
                  defaultValue={selectedRowData?.departmentId?.toString()}
                  disabled={edit}
                  className="w-full"
                  placeholder="Select Department"
                  showArrow
                >
                  {(departmentres?.getDepartments || []).map(item => (
                    <Select.Option key={item.id} value={item.id}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        )}
        {/* <div className="mt-5 bg-[#E2E8F0] "></div> */}

        <div
          style={{
            background: "#F8FAFC",
            padding: "20px",
            border: "1px solid #CCCCCC",
            borderRadius: "12px",
          }}
        >
          <Form.List name="holidays">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }, index) => (
                  <Row key={key} gutter={24} align="middle" style={{ marginBottom: 8 }}>
                    <Col span={12}>
                      <Form.Item
                        {...restField}
                        name={[name, "holidayName"]}
                        fieldKey={[fieldKey, "holidayName"]}
                        label="Holiday Name"
                        rules={[{ required: true, message: "Please enter holiday name" }]}
                      >
                        <Input placeholder="Enter holiday name" />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "date"]}
                        fieldKey={[fieldKey, "date"]}
                        label="Date"
                        rules={[{ required: true, message: "Please select date" }]}
                      >
                        <DatePicker format="DD/MM/YYYY" placeholder="DD/MM/YYYY" />
                      </Form.Item>
                    </Col>

                    <Col span={2} style={{ marginTop: "5px" }}>
                      {fields.length > 1 && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={14}
                          height={15}
                          fill="none"
                          {...props}
                          onClick={() => remove(name)}
                        >
                          <path
                            fill="#EF4444"
                            d="M12.5 3h-2.25v-.75A1.75 1.75 0 0 0 8.5.5h-3a1.75 1.75 0 0 0-1.75 1.75V3H1.5a.75.75 0 0 0 0 1.5h.25V13A1.25 1.25 0 0 0 3 14.25h8A1.25 1.25 0 0 0 12.25 13V4.5h.25a.75.75 0 1 0 0-1.5Zm-7.25-.75A.25.25 0 0 1 5.5 2h3a.25.25 0 0 1 .25.25V3h-3.5v-.75Zm5.5 10.5h-7.5V4.5h7.5v8.25ZM6.25 6.5v4a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 1.5 0Zm3 0v4a.75.75 0 1 1-1.5 0v-4a.75.75 0 0 1 1.5 0Z"
                          />
                        </svg>
                      )}
                    </Col>
                    {fields.length - 1 === index && (
                      <Col span={2}>
                        {fields.length === 1 && (
                          <Button
                            onClick={() => add()}
                            style={{
                              width: "24px",
                              height: "24px",
                            }}
                            icon={
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={12}
                                height={15}
                                fill="none"
                                {...props}
                              >
                                <path
                                  stroke="#3B82F6"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={1.5}
                                  d="M6 2.875v6.25M9.125 6h-6.25"
                                />
                              </svg>
                            }
                          />
                        )}
                        {fields.length > 1 && (
                          <Form.Item>
                            <Button
                              onClick={() => add()}
                              style={{
                                width: "24px",
                                height: "24px",
                                marginTop: "30px",
                              }}
                              icon={
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={12}
                                  height={15}
                                  fill="none"
                                  {...props}
                                >
                                  <path
                                    stroke="#3B82F6"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={1.5}
                                    d="M6 2.875v6.25M9.125 6h-6.25"
                                  />
                                </svg>
                              }
                            />
                          </Form.Item>
                        )}
                      </Col>
                    )}
                  </Row>
                ))}
              </>
            )}
          </Form.List>
        </div>
      </Form>
    </div>
  );
};

export default HolidayForm;
